import { useEffect } from "react";
import {
  Typography,
  Container,
  Fab,
  useTheme as muiTheme,
  Box
} from "@mui/material";
import { AutoAwesome, Close as CloseIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import useBotChat from "../../hooks/useBotChat";
import AskMeAnythingChatBotContent from "./AskMeAnythingChatBotContent";

function AskMeAnythingChatBot() {
  const { t } = useTranslation();
  const theme = muiTheme();
  const { open: showChat, setOpen: setShowChat } = useBotChat();

  useEffect(() => {
    const storedOpen = sessionStorage.getItem("chatbot-open");
    if (storedOpen) {
      setShowChat(JSON.parse(storedOpen));
    }
  }, [setShowChat]);

  const onClickChatBot = () => {
    setShowChat(!showChat);
  };

  return (
    <Container
      sx={{
        background: "red",
        position: "relative",
        zIndex: theme.zIndex.modal + 1
      }}
      className="ask-me-anything-chatbot-container"
    >
      {showChat && (
        <Box
          sx={{
            position: "fixed",
            right: 20,
            bottom: 80,
            zIndex: theme.zIndex.modal + 1
          }}
        >
          <AskMeAnythingChatBotContent />
        </Box>
      )}
      <Fab
        id="close-chat-button"
        color="primary"
        onClick={() => onClickChatBot()}
        size="medium"
        sx={{
          borderRadius: 48,
          opacity: 0.4,
          transition: "all 0.3s ease-in-out",
          width: "auto",
          position: "absolute",
          right: 0,
          bottom: 0,
          height: "50px",
          paddingX: "14px",
          "&:hover": {
            opacity: 1,
            "& .fab-text": {
              opacity: 1,
              maxWidth: "200px",
              marginLeft: 3
            }
          }
        }}
      >
        {showChat ? (
          <CloseIcon />
        ) : (
          <>
            <AutoAwesome />
            <Typography
              className="fab-text"
              sx={{
                opacity: 0,
                maxWidth: 0,
                overflow: "hidden",
                whiteSpace: "nowrap",
                transition: "all 0.3s ease-in-out",
                fontSize: "0.875rem"
              }}
            >
              {t("Ask a question")}
            </Typography>
          </>
        )}
      </Fab>
    </Container>
  );
}

export default AskMeAnythingChatBot;
